// extracted by mini-css-extract-plugin
export default {"root":"ImageUppyUploadZone__root--d1unF"};